export function getBadgeVariant(
  status: string,
): "success" | "warning" | "secondary" | "destructive" {
  let badgeVariant: "success" | "warning" | "secondary" | "destructive";

  if (status === "SUCCESS") {
    badgeVariant = "success";
  } else if (status === "IN PROGRESS" || status === "IN_PROGRESS") {
    badgeVariant = "warning";
  } else if (status === "ERROR" || status === "FAILED") {
    badgeVariant = "destructive";
  } else {
    badgeVariant = "secondary";
  }
  return badgeVariant;
}
